/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useMemo, useState } from 'react';

// Extend the Window interface to include applePaySession
declare global {
  interface Window {
    ApplePaySession?: any;
  }
}

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

import googlePay from '@/assets/google-pay.svg';
import applePay from '@/assets/apple-pay.svg';

import { PaymentMethods } from '../../types/paymentLinkContextTypes';

interface IPaymentMethod {
  id: PaymentMethods;
  label: string;
  fast?: boolean;
  asset?: string;
}

export default function usePaymentMethods() {
  const { setCurrentStep, maxSteps, paymentLinkData } =
    useContext(PaymentLinkContext);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [installmentsType, setInstallmentsType] = useState('');

  const handleItemClick = (type: PaymentMethods) => {
    setInstallmentsType(type);
  };

  const handleContinue = () => {
    if (!installmentsType) return;

    if (installmentsType === 'credit_card') {
      return setCurrentStep('personal');
    }

    setDrawerOpen(true);
  };

  const paymentMethods: IPaymentMethod[] = useMemo(() => {
    const methods: IPaymentMethod[] = [];

    if (
      window?.ApplePaySession &&
      window.ApplePaySession.canMakePayments() &&
      paymentLinkData?.mof_show_apple_wallet
    ) {
      methods.push({
        id: 'apple_pay',
        label: 'Apple Pay',
        fast: true,
        asset: applePay,
      });
    }

    if (
      window?.google?.payments?.api?.PaymentsClient &&
      paymentLinkData?.mof_show_google_wallet
    ) {
      methods.push({
        id: 'google_pay',
        label: 'Google Pay',
        fast: true,
        asset: googlePay,
      });
    }

    methods.push({
      id: 'credit_card',
      label: 'Cartão de crédito',
    });

    return methods;
  }, []);

  return {
    paymentMethods,
    handleItemClick,
    installmentsType,
    setInstallmentsType,
    drawerOpen,
    setDrawerOpen,
    setCurrentStep,
    maxSteps,
    handleContinue,
  };
}
